module.exports = __webpack_public_path__ + "static/media/testimonial-avatar-1.404a9a20.jpg";